import styled from "styled-components";
import { Theme, Box, TextField } from "@material-ui/core";
import ExpandPolygonIcon from "../../../../../../icons/ExpandPolygon";
import { TextFieldProps } from "@material-ui/core";
import * as React from "react";
import type { FC } from "react";

const BACKGROUND_COLOR = "rgba(43, 57, 64, 0.07)";
const LABEL_COLOR = "rgba(43, 57, 64, 0.5)";

const propsAs = (props: unknown) => {
  return props as any;
};

const theme = (props: any) => {
  return props.theme as Theme;
};

export const InputIcon = styled(ExpandPolygonIcon)((props) => ({
  transform: `rotate(${propsAs(props)["open"] ? 180 : 0}deg)`,
  width: theme(props).spacing(1),
  height: theme(props).spacing(0.75),
  padding: theme(props).spacing(1.5),
  boxSizing: "content-box",
})) as typeof ExpandPolygonIcon & FC<{ open: boolean }>;

export const InputBox = styled(Box)((props) => ({})) as typeof Box;

export const InputTextField = styled(TextField)((props) => ({
  marginLeft: theme(props).spacing(1),
  width: theme(props).spacing(propsAs(props)["inputLarge"] ? 23 : 20),
  cursor: "pointer",
  overflow: "hidden",

  "& .hierarchy-input": {
    userSelect: "none",
    minHeight: theme(props).spacing(4),
    cursor: "pointer",
    background: BACKGROUND_COLOR,
    borderColor: propsAs(props)["open"] ? theme(props).palette.primary.main : BACKGROUND_COLOR,
    borderRadius: "3px",
    borderStyle: "solid",
    borderWidth: "1px",
    "&:before": {
      display: "none",
    },
    "&:after": {
      display: "none",
    },
    "& input": {
      userSelect: "none",
      padding: theme(props).spacing(1),
      color: "transparent",
      textShadow: "0 0 0 #2B3940",
      fontSize: "14px",
      lineHeight: "17px",
    },
  },

  "& .hierarchy-label": {
    fontSize: "14px",
    lineHeight: "16px",
    color: propsAs(props)["open"] ? theme(props).palette.primary.main : LABEL_COLOR,
  },
})) as React.FC<{ inputLarge?: boolean; open?: boolean } & TextFieldProps>;
